export default __webpack_public_path__ + "static/media/new5.fa488b5b.jpg";